import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface ScheduleAddTaskActionsProps {
    date?: Date;
    menuKey: string | null;
    onCreateTask: (date?: Date, precision?: 'hour' | 'day' | 'month' | 'year') => void;
    onMenuChange: (key: string | null) => void;
    onPickExistingTask: (date?: Date) => void;
    precision?: 'hour' | 'day' | 'month' | 'year';
}

export const ScheduleAddTaskActions: React.FC<ScheduleAddTaskActionsProps> = ({
    date, menuKey, onCreateTask, onMenuChange, onPickExistingTask, precision = 'day',
}) => {
    const { t } = useTranslation();
    const ref = useRef<HTMLDivElement>(null);
    const key = `${precision}-${date?.toISOString() || 'global'}`;
    const isOpen = menuKey === key;
    useEffect(() => {
        if (!isOpen) return undefined;
        const close = (event: PointerEvent) => {
            if (!ref.current?.contains(event.target as Node)) onMenuChange(null);
        };
        document.addEventListener('pointerdown', close);
        return () => document.removeEventListener('pointerdown', close);
    }, [isOpen, onMenuChange]);
    return (
        <div ref={isOpen ? ref : undefined} className="schedule-add-task-actions">
            <button type="button" className="schedule-add-task-button"
                onClick={() => onMenuChange(isOpen ? null : key)}
                aria-label={t('dailyPlanner.addTask')} title={t('dailyPlanner.addTask')}>+</button>
            {isOpen && (
                <div className="schedule-add-task-menu" role="menu">
                    <button type="button" role="menuitem" onClick={() => { onCreateTask(date, precision); onMenuChange(null); }}>
                        {t('dailyPlanner.newTask')}
                    </button>
                    <button type="button" role="menuitem" onClick={() => { onPickExistingTask(date); onMenuChange(null); }}>
                        {t('dailyPlanner.existingTask')}
                    </button>
                </div>
            )}
        </div>
    );
};
